import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';

import React, { useMemo, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import MainCard from 'ui-component/cards/MainCard';
import { Delete as DeleteIcon } from '@mui/icons-material';
import DocumentUploader from 'ui-component/uploadDocument';
import axios from 'axios';
import toast from 'react-hot-toast';
import { get, post, put } from '../../axios/apiService';
import { useNavigate } from 'react-router';
import LoadingBackdrop from 'ui-component/full-screen-loadder/LoadingBackdrop';
import { addPercentage, isEmpty, validateAmount, validateMaxLength } from 'utils/validator';
import { useEffect } from 'react';
import { getFileNameFromUrl } from 'utils/urlToGetFileName';
import uploadFilesService from '../../axios/uploadFilesService';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Stack, styled } from '@mui/system';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { generateUniqueId } from 'utils/commonfunction';
import NomineeDetails from 'ui-component/nomineeDetail';
import PhoneInput from 'react-phone-input-2';

const ResizableTextField = styled(TextField)({
  '& .MuiInputBase-inputMultiline': {
    resize: 'both',
    overflow: 'auto',
  },
});
function AddEditLoansForm({ id, setIsShowForm, customerId }) {
  console.log('id', id);
  const [typeValues, setTypeValues] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [isValidation, setIsValidation] = useState(false);
  const [isValidationNominee, setIsValidationNominee] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [usedLoanNominees, setUsedLoanNominees] = useState([]);

  const {
    control: nomineesControl,
    getValues: nomineesGetValues,
    reset: nomineesReset,
    watch: nomineesWatch,
  } = useForm({
    defaultValues: {
      address: "",
      firstName: "",
      lastName: "",
      phone: "",
    },
  });

  const { control, handleSubmit, getValues, reset, watch } = useForm({
    defaultValues: {
      loanId: '',
      loanType: null,
      bank: '',
      loanNumber: '',
      amount: 0,
      premium: 0,
      termInMonths: 0,
      startDate: '',
      endDate: '',
      currentRateOfInterest: 0,
    }
  });
  const navigate = useNavigate();
  const [documentList, setDocumentList] = useState([]);
  const [existingDoc, setExistingDoc] = useState([]);

  const formValues = useMemo(() => ({
    termInMonths: watch('termInMonths'),
    amount: watch('amount'),
    currentRateOfInterest: watch('currentRateOfInterest'),
    loanType: watch('loanType'),
    bank: watch('bank'),
    loanNumber: watch('loanNumber'),
    premium: watch('premium'),
    startDate: watch('startDate'),
    endDate: watch('endDate'),
  }), [
    watch('termInMonths'),
    watch('amount'),
    watch('currentRateOfInterest'),
    watch('loanType'),
    watch('bank'),
    watch('loanNumber'),
    watch('premium'),
    watch('startDate'),
    watch('endDate'),
  ]);

  const columns = [
    { field: "firstName", headerName: "First Name", flex: 1 },
    { field: "lastName", headerName: "Last Name", flex: 1 },
    { field: "phone", headerName: "Phone Number", flex: 1 },
    { field: "address", headerName: "Address", flex: 1 },
    { field: "allocationPercentage", headerName: "Allocation Percentage", flex: 1 },
    {
      field: "action",
      headerName: "Actions",
      renderCell: (params) => <ActionButtons {...params.row} />,
      // align: 'right',
      width: 200,
      sortable: false,
      filterable: false,
    },
  ];

  useEffect(() => {
    if (isValidation) {
      validator(formValues);
    }
  }, [formValues, isValidation]);



  useEffect(() => {
    if (isValidationNominee) {
      const formNomineesData = {
        firstName: nomineesWatch("firstName"),
        lastName: nomineesWatch("lastName"),
        address: nomineesWatch("address"),
        phone: nomineesWatch("phone"),
        allocationPercentage: nomineesWatch("allocationPercentage"),
      };
      validateNominees(formNomineesData);
    }
  }, [isValidationNominee, nomineesWatch("firstName"), nomineesWatch("lastName"), nomineesWatch("address"), nomineesWatch("phone"), nomineesWatch("allocationPercentage")]);


  const handleCancel = () => {
    setIsShowForm(false);
  };

  useEffect(() => {
    const fetchTypes = async () => {
      try {
        let response = await get(`WillTypeMaster/Loans`);
        setTypeValues(response);
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchTypes();

    if (id) {
      const getByIdLoan = async () => {
        setIsLoading(true);
        try {
          let response = await get(`Loans/getAllDetailByLoanID/${id}`, null);
          if (response != null) {
            reset({
              loanId: response?.id || '',
              amount: response?.amount || 0,
              bank: response.bank || '',
              currentRateOfInterest: response.currentRateOfInterest || 0,
              endDate: formatDate(response.endDate) || '',
              loanDocuments: response.loanDocuments || '',
              loanNumber: response.loanNumber || '',
              loanType: response.loanType || '',
              premium: response.premium || 0,
              startDate: formatDate(response.startDate) || '',
              termInMonths: response.termInMonths || 0,
            });
            // let existDocList = response.loanDocuments?.map(x => {
            //   let fileName = getFileNameFromUrl(x.blobUrl);
            //   return { ...x, fileName }
            // })
            setExistingDoc(response.loanDocuments);
            setUsedLoanNominees(response.loanNominees);
            console.log("response.loanNominees", response.loanNominees)
          }
        } catch (err) {
          console.error(err?.message);
        } finally {
          setIsLoading(false);
        }
      };
      getByIdLoan();
    }
  }, [id]);

  const handleUpload = (newFiles) => {
    setDocumentList((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const handleRemove = (index) => {
    setDocumentList((prevDocuments) => prevDocuments.filter((_, i) => i !== index));
  };
  const handleRemoveExistDoc = (index) => {
    setExistingDoc((prevDocuments) => prevDocuments.filter((_, i) => i !== index));
  };

  const onSubmit = async (data) => {
    setIsValidation(true);
    if (!validator()) return;
    let uploadFileList = await uploadDocBlob();
    let loanDocuments =
      uploadFileList?.map((x) => ({
        blobUrl: x.fileName,
        fileName: documentList[x.fileId - 1].name
      })) || [];

    if (usedLoanNominees.length == 0) {
      toast.error("Please add at least one nominee");
      return;
    }
    let allocationTotal = 0;
    usedLoanNominees.forEach((x) => (allocationTotal += parseFloat(x.allocationPercentage.toString())));
    if (allocationTotal != 100) {
      toast.error("Allocation of all nominee(s) must be 100%");
      return;
    }
    if (!customerId) {
      toast.error('Please select customer');
      return;
    }

    const apiUrl = id ? `Loans/${id}` : 'Loans';
    let param = {
      loans: {
        ...data,
        loanType: data.loanType,
        amount: Number(data.amount),
        premium: Number(data.premium),
        currentRateOfInterest: Number(data.currentRateOfInterest),
        termInMonths: Number(data.termInMonths),
        //loanDocuments: loanDocuments || [],
        customerId: customerId,
      },
      loneNominees: usedLoanNominees,
      LoansDocuments: loanDocuments || [],
    };
    if (id) {
      param.id = id;
      // let existingFileName = existingDoc.map(x => { return { blobUrl: x.fileName } });
      let existingFileName = existingDoc?.map((x) => {
        let urlName = getFileNameFromUrl(x.blobUrl);
        return { ...x, blobUrl: urlName };
      });
      param.loanDocuments = [...loanDocuments, ...existingFileName];
    }

    try {
      setIsLoading(true);
      let response = id ? await put(apiUrl, param) : await post(apiUrl, param);
      if (response) {
        toast.success(id ? 'Loan updated successfully' : 'Loan added successfully');
      }
      navigate('/will-management');
    } catch (error) {
      toast.error('Failed to save loan. Please try again.');
    } finally {
      setIsLoading(false);
    }
    setIsValidation(false);
    setIsShowForm(false);
  };

  const uploadDocBlob = async (data) => {
    const formData = new FormData();
    for (let i = 0; i < documentList.length; i++) {
      formData.append('files', documentList[i]);
      formData.append('fileIds', i + 1);
    }
    formData.append('categoryId', 2);
    try {
      let data = await uploadFilesService(formData);
      return data;
    } catch (error) {
      console.error('There was an error uploading the files!', error);
    }
  };

  const validator = () => {
    let data = getValues();
    const errors = {};
    if (isEmpty(data?.bank)) {
      errors.bank = 'Please Enter Bank name';
    }

    if (!validateMaxLength(data?.bank, 100)) {
      errors.bank = ` The value exceeds the maximum allowed length of ${100} characters.`;
    }

    if (isEmpty(data?.loanNumber)) {
      errors.loanNumber = 'Please Enter Loan Number';
    }
    if (!validateMaxLength(data?.loanNumber, 100)) {
      errors.loanNumber = ` The value exceeds the maximum allowed length of ${100} characters.`;
    }

    if (!validateAmount(data.amount, 1)) {
      errors.amount = "Please enter a valid Amount greater than or equal to 1.";
    }

    if (!validateAmount(data.premium, 1)) {
      errors.premium = "Please enter a valid Permium greater than or equal to 1.";
    }

    if (!validateAmount(data.currentRateOfInterest, 1)) {
      errors.currentRateOfInterest = "Please enter a valid CurrentRateOfInterest greater than or equal to 1.";
    }

    if (!validateAmount(data.termInMonths, 1)) {
      errors.termInMonths = "Please enter a valid TermsInMonth greater than or equal to 1.";
    }
    if (data?.loanType == null || data?.loanType == undefined) {
      errors.loanType = 'Please Select Loan Type';
    }

    if (!data?.startDate) {
      errors.startDate = 'Please Enter Start Date';
    }

    if (!data?.endDate) {
      errors.endDate = 'Please Enter End Date';
    }

    if (data?.startDate && data?.endDate) {
      const startDate = new Date(data.startDate);
      const endDate = new Date(data.endDate);

      if (startDate >= endDate) {
        errors.endDate = 'End Date must be greater than Start Date';
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const saveNominees = () => {
    let nomineesData = {
      firstName: nomineesGetValues("firstName"),
      lastName: nomineesGetValues("lastName"),
      address: nomineesGetValues("address"),
      phone: nomineesGetValues("phone"),
      id: generateUniqueId(),
      allocationPercentage: nomineesGetValues("allocationPercentage"),
    };
    setIsValidationNominee(true);
    if (!validateNominees(nomineesData)) return;
    setIsValidationNominee(false);
    try {
      setIsLoading(true);
      let newNominees = usedLoanNominees;
      newNominees = [...newNominees, ...[nomineesData]];
      setUsedLoanNominees(newNominees);
      nomineesReset({
        address: "",
        firstName: "",
        id: "",
        lastName: "",
        phone: "",
        allocationPercentage: 0,
      });
    } catch (error) {
      console.error("An error occurred while saving nominees:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const validateNominees = (nomineesData) => {
    const errors = {};

    if (isEmpty(nomineesData?.firstName)) {
      errors.firstName = "Please Enter First Name";
    }

    if (isEmpty(nomineesData?.lastName)) {
      errors.lastName = "Please Enter Last Name";
    }
    let mobileNumber = nomineesData?.phone && nomineesData?.phone.startsWith('+') ? nomineesData?.phone : `+${nomineesData?.phone}`;
    let phoneNumber = parsePhoneNumberFromString(mobileNumber);

    if (!phoneNumber || !phoneNumber.isValid()) {
      errors.phone = "Invalid Phone Number";
    }

    if (isEmpty(nomineesData?.address)) {
      errors.address = "Please Enter Address";
    }

    // if (!validateAmount(nomineesData?.allocationPercentage, 1)) {
    //   errors.allocationPercentage = "Please enter a valid Allocation Percentage greater than or equal to 1.";
    // }
    // if (!isNaN(nomineesData?.allocationPercentage) && nomineesData?.allocationPercentage > 100) {
    //   errors.allocationPercentage = "Please enter a valid Allocation Percentage less than or equal to 100.";
    // }

    // if(!isNaN(nomineesData?.allocationPercentage) && !addPercentage(nomineesData?.allocationPercentage,usedLoanNominees)){
    //   errors.allocationPercentage = "Please enter a valid Allocation Percentage less than or equal to 100.";
    // }

    if (!validateAmount(nomineesData?.allocationPercentage, 1)) {
      errors.allocationPercentage = "Please enter a valid Allocation Percentage greater than or equal to 1.";
    } else if (!isNaN(nomineesData?.allocationPercentage) && nomineesData?.allocationPercentage > 100) {
      errors.allocationPercentage = "Please enter a valid Allocation Percentage less than or equal to 100.";
    } else {
      let allocationTotal = parseFloat(nomineesData?.allocationPercentage?.toString());
      usedLoanNominees
        .filter((x) => x.id != nomineesData?.id)
        .forEach((x) => (allocationTotal += parseFloat(x.allocationPercentage.toString())));
      if (allocationTotal > 100) {
        errors.allocationPercentage = "Allocation of all nominee(s) must be 100%";
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const ActionButtons = (row) => {
    return (
      <Stack
        direction={"row"}
        spacing={1}
        justifyContent="center"
        sx={{ marginTop: "10px" }}
      >
        <Button
          color="primary"
          size="small"
          variant="contained"
          onClick={() => {
            handleNomineeEdit(row.id);
          }}
        >
          Edit
        </Button>
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={() => {
            setUsedLoanNominees((prevItems) => prevItems.filter((item) => item.id != row.id));
          }}
        >
          Delete
        </Button>
      </Stack>
    );
  };
  const handleNomineeEdit = (nomineeId) => {
    let existingNominee = usedLoanNominees.filter((x) => x.id == nomineeId);
    const updatedNominees = usedLoanNominees.filter((nominee) => nominee.id !== nomineeId);
    setUsedLoanNominees(updatedNominees);
    if (existingNominee && existingNominee[0]) {
      nomineesReset({
        address: existingNominee[0].address,
        allocationPercentage: existingNominee[0].allocationPercentage,
        firstName: existingNominee[0].firstName,
        lastName: existingNominee[0].lastName,
        phone: existingNominee[0].phone,
        id: existingNominee[0].id,
      });
    }
  };

  return (
    // <MainCard title="Insurance Form">
    <>
      <Box sx={{ padding: '30px 0' }}>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" color="primary" onClick={() => setIsShowForm(false)} startIcon={<ArrowBackIcon />}>
              Back
            </Button>
          </Box>
        </Grid>
        {/* <Typography variant="h3">Loan Form</Typography> */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <fieldset style={styles.fieldset}>
            <legend style={styles.legend}>Loan Information</legend>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <InputLabel id="type-label">Loan Type</InputLabel>
                  <Controller
                    name="loanType"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Select labelId="type-label" label="Loan Type" {...field}>
                          {typeValues &&
                            typeValues.map((x, i) => (
                              <MenuItem value={x.id} key={i}>
                                {x.name}
                              </MenuItem>
                            ))}
                        </Select>
                      </>
                    )}
                  />
                  <div style={{ color: 'red' }}>{formErrors.loanType}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="bank" control={control} render={({ field }) => <TextField {...field} label="Bank Name" />} />
                  <div style={{ color: 'red' }}>{formErrors.bank}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="loanNumber" control={control} render={({ field }) => <TextField {...field} label="Loan Number" />} />
                  <div style={{ color: 'red' }}>{formErrors.loanNumber}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="amount"
                    control={control}
                    render={({ field }) => <TextField {...field} type="number" label="Loan Amount" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.amount}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="premium" control={control} render={({ field }) => <TextField {...field} type="number" label="EMI" />} />
                  <div style={{ color: 'red' }}>{formErrors.premium}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="termInMonths"
                    control={control}
                    render={({ field }) => <TextField {...field} type="number" label="Term In Months" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.termInMonths}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="startDate"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        id="maturity-date"
                        InputLabelProps={{
                          shrink: true
                        }}
                        fullWidth
                        {...field}
                        type="date"
                        label="Start Date"
                      />
                    )}
                  />
                  <div style={{ color: 'red' }}>{formErrors.startDate}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="endDate"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        id="maturity-date"
                        InputLabelProps={{
                          shrink: true
                        }}
                        fullWidth
                        {...field}
                        type="date"
                        label="End Date"
                      />
                    )}
                  />
                  <div style={{ color: 'red' }}>{formErrors.endDate}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="currentRateOfInterest"
                    control={control}
                    render={({ field }) => <TextField {...field} type="number" label="Current Rate Of Interest" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.currentRateOfInterest}</div>
                </FormControl>
              </Grid>
            </Grid>
          </fieldset>
          <fieldset style={{ ...styles.fieldset, marginTop: '10px' }}>
            <legend style={styles.legend}>Document Information</legend>
            <DocumentUploader
              onUpload={handleUpload}
              documentList={documentList}
              onRemove={handleRemove}
              onRemoveExistDoc={handleRemoveExistDoc}
              existDocumentList={existingDoc}
            />
          </fieldset>
          <fieldset style={styles.fieldset}>
            <legend style={styles.legend}>Loan Nominees Information</legend>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  {/* <InputLabel id="type-label">First Name</InputLabel> */}
                  <Controller
                    name="firstName"
                    control={nomineesControl}
                    render={({ field }) => <TextField {...field} label="First Name" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.firstName}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="lastName"
                    control={nomineesControl}
                    render={({ field }) => <TextField {...field} label="Last Name" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.lastName}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="phone"
                    control={nomineesControl}
                    render={({ field }) =>
                      <PhoneInput
                        {...field}
                        country={'in'}
                        onChange={(value) => field.onChange(value)}
                        inputStyle={{ width: '100%' }}
                      />
                    }
                  />
                  <div style={{ color: 'red' }}>{formErrors.phone}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller name="address" control={nomineesControl} render={({ field }) =>
                    <ResizableTextField
                      {...field}
                      label="Address"
                      multiline
                      rows={4}
                    />
                  } />
                  <div style={{ color: 'red' }}>{formErrors.address}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                  <Controller
                    name="allocationPercentage"
                    control={nomineesControl}
                    render={({ field }) => <TextField {...field} label="AllocationPercentage" />}
                  />
                  <div style={{ color: 'red' }}>{formErrors.allocationPercentage}</div>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Box style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    style={{ marginRight: "10px" }}
                    onClick={saveNominees}
                  >
                    Save Nominee
                  </Button>
                </Box>
              </Grid>
              {usedLoanNominees && usedLoanNominees.length > 0 && (
                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: '10px' }}>
                  <NomineeDetails nominees={usedLoanNominees} columns={columns} />
                </Grid>
              )}
            </Grid>
          </fieldset>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: '10px' }}>
            <Button type="submit" variant="contained" color="primary" className="mt-4" style={{ marginRight: '15px' }}>
              Submit
            </Button>
            <Button
              type="button"
              variant="contained"
              color="error"
              className="mt-4"
              onClick={() => {
                setIsShowForm(false);
              }}
            >
              Cancel
            </Button>
          </Grid>
        </form>
      </Box>
      <LoadingBackdrop open={isLoading} />
    </>
    // </MainCard>
  );
}

export default AddEditLoansForm;

const styles = {
  fieldset: {
    border: '1px solid #364152',
    borderRadius: '8px',
    padding: '20px'
  },
  legend: {
    color: '#364152',
    padding: '0 10px',
    fontSize: '18px'
  }
};
const formatDate = (isoDate) => {
  const date = new Date(isoDate);
  const year = date.getFullYear();
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const day = `0${date.getDate()}`.slice(-2);
  return `${year}-${month}-${day}`;
};
